module.exports = __webpack_public_path__ + "img/4life-logo.8dda00ea.svg";